import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Alert, AlertDescription } from './ui/alert';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Checkbox } from './ui/checkbox';
import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';
import ProductManagement from './ProductManagement';
import QuoteManagement from './QuoteManagement';
import LetterheadManagement from './LetterheadManagement';
import SettingsPanel from './SettingsPanel';

function AdminDashboard() {
    const [activeTab, setActiveTab] = useState('products');
    
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-orange-50 py-12">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold text-center mb-12 text-slate-800">Admin Dashboard</h1>
                
                <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
                    <TabsList className="grid w-full grid-cols-6">
                        <TabsTrigger value="products">Products</TabsTrigger>
                        <TabsTrigger value="quotes">Quotes</TabsTrigger>
                        <TabsTrigger value="users">Users</TabsTrigger>
                        <TabsTrigger value="roles">Roles</TabsTrigger>
                        <TabsTrigger value="letterheads">Letterheads</TabsTrigger>
                        <TabsTrigger value="settings">Settings</TabsTrigger>
                    </TabsList>
                    
                    <TabsContent value="products">
                        <ProductManagement />
                    </TabsContent>
                    
                    <TabsContent value="quotes">
                        <QuoteManagement />
                    </TabsContent>
                    
                    <TabsContent value="users">
                        <UserManagement />
                    </TabsContent>
                    
                    <TabsContent value="roles">
                        <RoleManagement />
                    </TabsContent>
                    
                    <TabsContent value="letterheads">
                        <LetterheadManagement />
                    </TabsContent>
                    
                    <TabsContent value="settings">
                        <SettingsPanel />
                    </TabsContent>
                </Tabs>
            </div>
        </div>
    );
}

export default AdminDashboard;